import { Components, Theme } from '@mui/material/styles';

export const flowTextField: Components<Theme>['MuiTextField'] = {
  defaultProps: {
    variant: 'filled',
    minRows: 2,
    maxRows: 2,
    // NOTE: we are using deprecated @mui props instead of slotProps to allow projects to still use them as well
    // additionally, AutoComplete breaks when we overwrite slotProps
    inputProps: ({ placeholder, label }) => ({
      // add aria-label for fields without label but with placeholder
      ...(!label &&
        placeholder && {
          ['aria-label']: placeholder,
        }),
    }),
  },
  styleOverrides: {
    root: {
      // prevent overlap with end input adornment icon
      ':has(.MuiInputAdornment-positionEnd)': {
        '.MuiInputLabel-root': {
          paddingRight: '44px',
        },
      },
    },
  },
};
